import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import { PortalBulletin } from '~common/lib/models/portal-bulletin';
import { APIError } from '~common/lib/types';
import { MobileStepper } from '@mui/material';
import { Button } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Typography } from '@mui/material';

import { Paper } from '@mui/material';

const StepperInterval: number = 10000;

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
    marginBottom: 10
  },
  paperStyle: {
    margin: "0 auto"
  },
  caption: {
    borderBottom: '1px solid #ccc',
    padding: 10
  },
  body: {
    margin: 15,
    fontFamily: "Arial,san-serif,Helvetica,Trebuchet MS",
  },
  pinnedBody: {
    margin: 15,
    "&::before": {
      border: "1px solid #ffe002 !important",
      transform: "scaleX(1)"
    },
    fontFamily: "Arial,san-serif,Helvetica,Trebuchet MS",
  },
  bulletin: {
    minHeight: 200,
    postion: "relative"
  },
  empty: {
    margin: 15,
    paddingBottom: 10
  },
  stepperContainer: {
    bottom: 0,
    marginBottom: 2,
    width: '99%',
    position: "absolute"
  },
  pin: {
    position: 'absolute',
    top: 9,
    right: 30,
    opacity: 0.2,
    // backgroundColor: 'rgba(255,255,255,0.1)',
    zIndex: 10
  },
  pause: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    opacity: 0.4,
    zIndex: 10,
    '&:hover': {
      cursor: 'pointer'
    }
  }

});

interface Props extends React.HTMLProps<HTMLDivElement> {
  slideCount?: number
  filter?: any
  autoplaySpeed?: number
  bulletins?: Array<any>
  chromeless?: boolean
}

type State = {
  bulletins?: Array<any>
  error?: APIError;
  status: string;
  activeStep: number

};

class BulletinLister extends React.Component<Props & WithStyles<keyof typeof styles>, State> {


  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      bulletins: this.props.bulletins,
      status: "loading",
      activeStep: 0
    }

  }

  carouselTimer?: any

  getState = () => {

  }
  // UNSAFE_componentWillReceiveProps(props: any) {

  // }
 componentDidMount() {
    if (this.state.bulletins == undefined) {
      // console.log("Bulletins undefined")
      PortalBulletin.query(this.props.filter || {})
        .then((data: Array<PortalBulletin>) => {
          if (data && data.items && data.items.length > 1) {
            if (this.carouselTimer) {
              clearInterval(this.carouselTimer)
            }
            this.carouselTimer = setInterval(() => {
              this.handleNext()
            }, StepperInterval)
          }
          this.setState({ bulletins: data, status: 'ready' });
        })
        .catch((err) => {
          this.setState({ error: err, status: 'ready' });
        });
    } else {
      // console.log("Else State")
      if (this.state.bulletins && this.state.bulletins.items && this.state.bulletins.items.length > 1) {
        if (this.carouselTimer) {
          clearInterval(this.carouselTimer)
        }
        // console.log("Setting Interval")
        this.carouselTimer = setInterval(() => {
          this.handleNext()
        }, 10000)
      }
      this.setState({ status: 'ready' });
    }


  }

  componentWillUnmount() {
    clearInterval(this.carouselTimer)
  }

  handleManualNext = () => {
    this.handleNext()
    if (this.carouselTimer) {
      this.carouselTimer = clearInterval(this.carouselTimer)      
    }
    this.setState({});
  };

  handleNext = () => {
    if (this.state.activeStep >= this.state.bulletins.items.length - 1) {
      this.setState({
        activeStep: 0,
      });
    } else {
      this.setState({
        activeStep: this.state.activeStep + 1,
      });
    }
  };

  handleBack = () => {

    if (this.carouselTimer) {
      this.carouselTimer = clearInterval(this.carouselTimer)
    }
    this.setState({
      activeStep: this.state.activeStep - 1,
    });
  };

  pause = () => {
    if (this.carouselTimer) {
      this.carouselTimer = clearInterval(this.carouselTimer)
    } else {
      this.carouselTimer = setInterval(() => {
        this.handleNext()
      }, StepperInterval)
    }

    this.setState({})
  }

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    const { status, bulletins, activeStep } = this.state;
    const { chromeless } = this.props;
    if (!bulletins) {
      return null
    }
    var selector: any = null;


    if (bulletins.items && bulletins.items[activeStep].pinned > 0) {
      selector = (
        <i className={classes.pin + ' fa fa-thumbtack'} />
      );

    }
    var pause: any = (
      <i onClick={this.pause} className={classes.pause + (this.carouselTimer ? ' fa fa-pause' : ' fa fa-play')} />
    );


    switch (status) {
      case 'loading':
        return false
      default:
        if (!bulletins.items || (bulletins.items && bulletins.items.length == 0)) {
          // No presentation if no bulletins
          return false
        } else {

          if (chromeless) {
            // console.log("chromeless pinned?", bulletins.items[activeStep].pinned)
            return (
              <div className={classes.bulletin}>
                {pause}
                {selector}
                <div className={classes.pinnedBody} dangerouslySetInnerHTML={{ __html: bulletins.items[activeStep].body.value || bulletins.items[activeStep].body }} />
                {
                  (bulletins.items.length > 1) &&

                  <div className={classes.stepperContainer}>
                    <MobileStepper
                      steps={bulletins.items.length}
                      position="static"
                      activeStep={this.state.activeStep}
                      nextButton={
                        <Button onClick={this.handleManualNext} disabled={activeStep === bulletins.items.length - 1}>
                          Next
                            <KeyboardArrowRight />
                        </Button>
                      }
                      backButton={
                        <Button onClick={this.handleBack} disabled={activeStep === 0}>
                          <KeyboardArrowLeft />
                            Back
                          </Button>
                      }
                    >
                    </MobileStepper>
                  </div>
                }
              </div>
            )
          } else {
            // console.log("pinned?", bulletins.items[activeStep].pinned)
            return (
              <Paper className={classes.container}>
                <Typography className={classes.caption} variant="h6">
                  Bulletins
                </Typography>
                <div className={classes.bulletin}>
                  {selector}
                  <div className={classes.body} dangerouslySetInnerHTML={{ __html: bulletins.items[activeStep].body.value || bulletins.items[activeStep].body }} />
                </div>
                {bulletins.items.length > 1 &&
                  <div className={classes.stepperContainer}>
                    <MobileStepper
                      steps={bulletins.items.length}
                      position="static"
                      activeStep={this.state.activeStep}
                      nextButton={
                        <Button onClick={this.handleNext} disabled={activeStep === bulletins.items.length - 1}>
                          Next
                        <KeyboardArrowRight />
                        </Button>
                      }
                      backButton={
                        <Button onClick={this.handleBack} disabled={activeStep === 0}>
                          <KeyboardArrowLeft />
                        Back
                      </Button>
                      }
                    >
                    </MobileStepper>
                  </div>
                }

              </Paper>
            )
          }
        }
    }
  }
}
export default withStyles(styles)(BulletinLister);
